import React from 'react';
import { ResolvedIssueModal } from './resolved-issue-modal.component';
import { useResolvedIssueModalService } from './resolved-issue-modal.service';
import type { ResolvedIssueModalContainerProps } from './resolved-issue-modal.types';

export const ResolvedIssueModalContainer = (
  props: ResolvedIssueModalContainerProps,
) => {
  const serviceProps = useResolvedIssueModalService(props);
  return <ResolvedIssueModal {...serviceProps} />;
};
